"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTypeIcon = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../Icon");
const className = 'user-type-icon';
const iconMap = {
    customer: 'customer',
    agent: 'agent',
    manager: 'malesia',
    virtual: 'user-circle',
};
const UserTypeIcon = (props) => {
    var _a;
    const { userType, showDefault = false, defaultIconName = 'malesia', } = props;
    const icon = (_a = (userType ? iconMap[userType] : undefined)) !== null && _a !== void 0 ? _a : (showDefault ? defaultIconName : undefined);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, props.className) }, icon && (react_1.default.createElement(Icon_1.Icon, { name: icon }))));
};
exports.UserTypeIcon = UserTypeIcon;
//# sourceMappingURL=index.js.map